/* Clara & Luce — pop-up "Tu 10 % de bienvenida" conectado a Klaviyo.
   - Ordenador: a los 20 s o al intentar salir. Móvil: desde la 2ª página vista de la sesión, a los 25 s. Nunca en el editor del tema ni en el carrito.
   - Si se cierra, no vuelve en 7 días. Si se suscribe, no vuelve más.
   - Suscribe a la lista "Email List" de Klaviyo (dispara el flujo de bienvenida) y muestra el código al momento.
   - Pruebas: añadir ?clpopup=1 a cualquier URL para verlo al instante. */
(function () {
  var COMPANY = 'UisfiS';
  var LIST = 'Rw7xAf';
  var CODE = 'BIENVENIDA10';
  var DELAY = 20000;
  var KEY = 'cl_popup_state';
  var force = /[?&]clpopup=1/.test(location.search);

  if (window.Shopify && Shopify.designMode) return;
  if (!force && /^\/(cart|checkout|account|pages\/deja-tu-opinion)/.test(location.pathname)) return;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  var st = read();
  if (!force && (st.subscribed || (st.closedAt && Date.now() - st.closedAt < 7 * 864e5))) return;

  var css = ''
    + '.clp-ov{position:fixed;inset:0;background:rgba(17,17,17,.55);display:flex;align-items:center;justify-content:center;padding:16px;z-index:2147483000;opacity:0;transition:opacity .25s}'
    + '.clp-ov.is-in{opacity:1}'
    + '.clp{position:relative;width:100%;max-width:420px;background:#fff;color:#111;text-align:center;padding:36px 26px 24px;box-sizing:border-box;font-family:Outfit,Assistant,Arial,sans-serif;transform:translateY(12px);transition:transform .25s}'
    + '.clp-ov.is-in .clp{transform:none}'
    + '.clp-x{position:absolute;top:8px;right:8px;width:40px;height:40px;border:0;background:none;font-size:26px;line-height:40px;color:#111;cursor:pointer}'
    + '.clp-logo{display:block;width:170px;height:auto;margin:0 auto 18px}'
    + '.clp-line{width:56px;height:1px;background:#CAAC7E;margin:0 auto 18px}'
    + '.clp-k{font-size:12px;letter-spacing:3px;text-transform:uppercase;color:#8a7a5c;margin:0 0 8px}'
    + '.clp h2{font-family:"Tenor Sans",Georgia,serif;font-weight:400;font-size:30px;line-height:1.15;margin:0 0 12px;letter-spacing:.5px}'
    + '.clp p{font-size:15px;line-height:1.5;margin:0 0 18px;color:#3d3830}'
    + '.clp input{width:100%;box-sizing:border-box;height:50px;border:1px solid #cfc6b7;padding:0 14px;font-size:16px;font-family:inherit;margin:0 0 10px;border-radius:0;background:#fff;color:#111}'
    + '.clp input:focus{outline:2px solid #111;outline-offset:0}'
    + '.clp-b{width:100%;height:52px;border:0;background:#111;color:#fff;font-size:14px;letter-spacing:2px;font-weight:600;font-family:inherit;cursor:pointer;border-radius:0}'
    + '.clp-b[disabled]{opacity:.6}'
    + '.clp-no{display:inline-block;margin-top:14px;font-size:13px;color:#6b6358;text-decoration:underline;background:none;border:0;cursor:pointer;font-family:inherit}'
    + '.clp-legal{font-size:11px;line-height:1.45;color:#8b8378;margin:14px 0 0}'
    + '.clp-legal a{color:#8b8378}'
    + '.clp-err{font-size:13px;color:#a3262a;min-height:18px;margin:0 0 6px}'
    + '.clp-code{display:inline-block;border:1px dashed #CAAC7E;padding:12px 26px;font-size:24px;letter-spacing:4px;font-weight:600;margin:4px 0 18px}';

  function build() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var logo = 'https://claraeluce.com/cdn/shop/files/clara-luce-logo-nero.png?v=1790078164&width=400';
    var ov = document.createElement('div');
    ov.className = 'clp-ov';
    ov.innerHTML = ''
      + '<div class="clp" role="dialog" aria-modal="true" aria-labelledby="clp-t">'
      + '<button class="clp-x" type="button" aria-label="Cerrar">&times;</button>'
      + '<img class="clp-logo" src="' + logo + '" alt="Clara &amp; Luce" width="170" height="24">'
      + '<div class="clp-line"></div>'
      + '<div class="clp-step1">'
      + '<p class="clp-k">Solo para nuevas suscriptoras</p>'
      + '<h2 id="clp-t">Tu 10 % de bienvenida</h2>'
      + '<p>Suscríbete y llévate al momento un 10 % de descuento en tu primer pedido, además de novedades y ofertas exclusivas.</p>'
      + '<form novalidate>'
      + '<input type="email" name="email" autocomplete="email" inputmode="email" placeholder="Tu correo electrónico" aria-label="Tu correo electrónico" required>'
      + '<div class="clp-err" aria-live="polite"></div>'
      + '<button class="clp-b" type="submit">QUIERO MI 10 %</button>'
      + '</form>'
      + '<button class="clp-no" type="button">No, gracias</button>'
      + '<p class="clp-legal">Al suscribirte aceptas recibir correos comerciales de Clara &amp; Luce. Puedes darte de baja cuando quieras. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Política de privacidad</a></p>'
      + '</div>'
      + '<div class="clp-step2" hidden>'
      + '<h2>¡Bienvenida!</h2>'
      + '<p>Este es tu código del 10 % de descuento en tu primer pedido. Introdúcelo al pagar o actívalo ahora aquí abajo.</p>'
      + '<div class="clp-code">' + CODE + '</div>'
      + '<a class="clp-b" style="display:flex;align-items:center;justify-content:center;text-decoration:none" href="/discount/' + CODE + '?redirect=' + encodeURIComponent(location.pathname) + '">USAR EL CÓDIGO AHORA</a>'
      + '</div>'
      + '</div>';
    document.body.appendChild(ov);

    var box = ov.querySelector('.clp');
    var form = ov.querySelector('form');
    var input = ov.querySelector('input');
    var err = ov.querySelector('.clp-err');
    var btn = ov.querySelector('.clp-b');
    var lastFocus = document.activeElement;

    function close(remember) {
      if (remember) { st.closedAt = Date.now(); save(st); }
      ov.classList.remove('is-in');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { ov.remove(); }, 250);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }
    function onKey(e) { if (e.key === 'Escape') close(true); }

    ov.querySelector('.clp-x').addEventListener('click', function () { close(true); });
    ov.querySelector('.clp-no').addEventListener('click', function () { close(true); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(true); });
    document.addEventListener('keydown', onKey);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Introduce un correo electrónico válido.'; input.focus(); return; }
      err.textContent = '';
      btn.disabled = true;
      btn.textContent = 'UN ATTIMO…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Popup 10% sito',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        st.subscribed = true; save(st);
        ov.querySelector('.clp-step1').hidden = true;
        ov.querySelector('.clp-step2').hidden = false;
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'QUIERO MI 10 %';
        err.textContent = 'Qualcosa non ha funzionato. Riprova tra un momento.';
      });
    });

    requestAnimationFrame(function () { ov.classList.add('is-in'); setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 260); });
  }

  var shown = false;
  function cookieBannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && getComputedStyle(b).display !== 'none' && b.getBoundingClientRect().height > 0);
  }
  function show() {
    if (shown) return;
    if (cookieBannerOpen()) { setTimeout(show, 1500); return; } // nunca encima del aviso de cookies
    if (!force && document.querySelector('cart-drawer.active, cart-notification.active, .drawer.active')) { setTimeout(show, 3000); return; } // nunca con el carrito abierto
    shown = true;
    build();
  }

  // Móvil (2026-10-05): nunca en la página de entrada (la que llega del anuncio); desde la 2ª página vista y a los 25 s.
  var MOBILE = !(window.matchMedia && matchMedia('(pointer:fine)').matches);
  var views = 0;
  try { views = (parseInt(sessionStorage.getItem('cl_popup_views'), 10) || 0) + 1; sessionStorage.setItem('cl_popup_views', views); } catch (e) {}

  function start() {
    if (force) { show(); return; }
    if (MOBILE) { if (views >= 2) setTimeout(show, 25000); return; }
    setTimeout(show, DELAY);
    if (window.matchMedia && matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
